import React, { Component } from 'react';
import { connect } from 'react-redux';
import ContentRowView from './content-row-view';

class ContentRow extends Component {

  render() {
    if (this.props.permissionNeeded && !this.props.auth.permissions[this.props.permissionNeeded]) return null;
    return <ContentRowView {...this.props} />
  }

}

const mapStateToProps = (state) => ({
  auth: state.auth
});

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(ContentRow);



// WEBPACK FOOTER //
// ./src/components/common/content-row/content-row.js